import { render } from "./SectionBenefit.vue?vue&type=template&id=50218e68"
import script from "./SectionBenefit.vue?vue&type=script&lang=js"
export * from "./SectionBenefit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__